// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/happypack/loader.js?id=1!./~/happypack/loader.js?id=2!./~/sass-resources-loader/lib/loader.js?{"resources":["./app/scss/settings/params.scss","./app/scss/settings/mixins.scss"]}!./~/vue-loader/lib/style-compiler?{"id":"data-v-6e91fbfa","scoped":false,"hasInlineConfig":true}!./~/vue-loader/lib/selector.js?type=styles&index=0!./app/components/elements/PermanentView.vue
// module id = 551
// module chunks = 0